import { createStore } from 'stimulus-store';

export const facilitySelectionStore = createStore({
    name: 'facilitySelectionStore',
    type: Object,
    initialValue: {
        region: {
            id: '',
            name: ''
        },
        building: {
            id: '',
            name: ''
        },
        area: {
            id: '',
            name: ''
        },
        room: {
            id: '',
            name: ''
        }
    }
});